export const needSkipLocationsAssign = (roleCode, customRole, isFromLocationAssignment) => {
    if (isFromLocationAssignment) return true
    if (!customRole) return false
    return customRole?.components && !Object.values(customRole.components.locations).some(Boolean)
}
